export const StringUtils = {
  capitalize: (data: string) => data.charAt(0).toUpperCase() + data.slice(1).toLowerCase(),
};
